import React, {useEffect, useState} from 'react';
import Header from '../layout/Header';
import Footer from '../layout/Footer';
import Sidebar from '../layout/Sidebar';
import Breadcrumbs from '../../components/Reusables/Breadcrumbs';
import Descriptor from '../../components/Reusables/Descriptor';
import Dropdown from '../../components/Reusables/Dropdown';
import Calender from '../../components/Reusables/Calender';
import '../../scss/editproject.scss';
import ProjectInfo from '../Reusables/ProjectInfo';
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { parseBreadcrumbsList } from '../../store/Actions';
import getResponse from '../actions/Project';
import Spinner from '../Reusables/Spinner';
import RefreshToken from '../actions/RefreshToken';
import getResponseEntity from '../actions/Entity.js';
import EditProjectConfirm from '../popups/EditprojectConfirm';
import Snackbars from '../Reusables/Snackbar';
import { trim } from '../Reusables/Function';
import { convertToDateString } from '../Reusables/Function';
import MultiSelectionDropdown from '../Reusables/MultiSelectionDropdown';

function EditProject(props) {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [complete, setComplete] = useState(false);
    const [deleteform, setDeleteForm] = useState();
    const [deletefile, setDeleteFile] = useState();
    const [deletetask, setDeleteTask] = useState();
    const [uploadstate, setUpload] = useState(false);
    const [projectDetails, setProjectDetails] = useState([]);
    const [projectname, setProjectname] = useState(null);
    const [entityid, setEntityId] = useState([]);
    const [startdate, setStartdate] = useState(false);
    const [date, setDate] = useState(null);
    const [label, setLabel] = useState('Select Date');
    const [resend, setResend] = useState({
        date: null,
        startDate: false,
        label: 'Select Date',
      });

    const [adestraReport, setAdestraReport] = useState(null);
    const [adestraReportResend, setAdestraReportResend] = useState(null);
    const [description, setDescription] = useState(null);
    const [entityList, setEntityList] = useState([]);
    const [entityLabel, setEntityLabel] = useState('Select Property');
    const [isLoading, setLoading] = useState(true);
    const [editerror, setEditerror] = useState('');
    const [open, setOpen] = useState(null);
    const [showTask, setshowTask] = useState(false);
    const [projectTypeLabel, setprojectTypeLabel] = useState('Select Project Type');
    const [projectTypeId, setProjectTypeId] = useState(null);
    const [projectTypeList, setProjectTypeList] = useState([]);
    const [projectTypeEnable, setProjectTypeEnable] = useState(null);
    const [currentprojectType, setCurrentProjectType] = useState(null);
    const[currentBrand, setCurrentBrand] = useState(null);
    const [brandId, setBrandId] = useState(0);
    const [confirmButtonEnable, setConfirmButtonEnable] = useState(true);
    const [showeditconfirm, setShoweditconfirm] = useState(false);
    const [initialBrandId, setInitialBrandId] = useState(0);
    const handleConfirmHide = () => setShoweditconfirm(false);

    const handleConfirmShow = () => {
        setConfirmButtonEnable(true);
        setShoweditconfirm(true);
    }

    function SameEntity() {
        setConfirmButtonEnable(false);
        var exactdate = null;
        let datetime = date;
        if(datetime != null && datetime != "") {
            exactdate = convertToDateString(datetime, "");
        }

        let data = {
            "Idprojects" : id,
            "Name" : trim(projectname),
            "EntityIds" : entityid,
            "DueDate" : exactdate,
            "ResendDate": resend.date ? convertToDateString(resend.date, "") : null,
            "Description" : trim(description),
            "ResetTasks" : false,
            "ProjectTypeId": projectTypeId,
            "AdestraReport": trim(adestraReport),
            "AdestraReportResend": trim(adestraReportResend)
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponse.EditProject(data, id, accesstoken, (response) => {       
                    setConfirmButtonEnable(true)
                    if(response.status === 200) {
                        setLoading(true)
                        navigate(`/projects/${id}/view`);
                        setOpen(false)
                    }
                    if(response.status === 400) {
                        setLoading(false)
                        setEditerror(response.data.message);
                        setOpen(true)
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function DifferentEntity() {
        setConfirmButtonEnable(false);
        var exactdate = null;
        let datetime = date;
        if(datetime != null && datetime != "") {
            exactdate = convertToDateString(datetime, "");
        }

        let data = {
            "Idprojects" : id,
            "Name" : trim(projectname),
            "EntityIds" : entityid,
            "DueDate" : exactdate,
            "ResendDate": resend.date ? convertToDateString(resend.date, "") : null,
            "Description" : trim(description),
            "ResetTasks" : true,
            "ProjectTypeId": projectTypeId,
            "AdestraReport": trim(adestraReport),
            "AdestraReportResend": trim(adestraReportResend)
        }

        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                getResponse.EditProject(data, id, accesstoken, (response) => {  
                    setConfirmButtonEnable(true)
                    if(response.status == 200) {
                        setshowTask(!showTask)       
                        console.log("Editresponse", response);
                        navigate(`/projects/${id}/view`);
                    } else if(response.status === 400) {
                        setLoading(false)
                        setEditerror(response.data.message);
                        setOpen(true)
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }

    function SaveProject() {  
        console.log("Brand Ids ", brandId, currentBrand);
        if(brandId == currentBrand && projectTypeId == currentprojectType) {
                SameEntity();
        } else {
            handleConfirmShow();
        }
    }

    function handledate(date) {
        setDate(date);
        setStartdate(date);
    }

    function handleResendDate(date) {
        setResend((prev) => ({ ...prev, date: date, startDate: date }));
    }

    function GetDropdown(accesstoken) {
        const endpoint = "/api/entity/dropdown";
        getResponse.GetEntityDropdown(accesstoken, endpoint, (response) => {    
            if(response.status == 200) {
                const entityArray = [];
                response.data.data.map((task) => {
                    const entityObject = {id: 0, name: '', brandId: null}
                    entityObject.id = task["idEntities"];
                    entityObject.name = task["entityName"];
                    entityObject.propertyCode = task["entityName"].split(' -')[0]
                    entityObject.brandId = task["brandId"];
                    entityObject.parentBrand = task["parentBrand"]
                    entityArray.push(entityObject);
                })
                setEntityList(entityArray);
            } else if(response.status == 401) {
                navigate("/login")
            }  
        });
    }

    useEffect(() => {
        function CallAPI(accesstoken) {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                GetDropdown(accesstoken);
                const URL = `/api/Project/projectdetails/${id}`
                getResponse.GetProjectDetails(URL, accesstoken, (response) => {  
                    if(response.status == 200) {
                        console.log("ProjectDetailsresponse", response.data);
                        setProjectDetails(response.data);
                        if(response.data != null) {
                            if(response.data.name != null) {
                                setProjectname(response.data.name)
                            } 
                            if(response.data.dueDate != null) {
                                const date = new Date(response.data.dueDate);
                                setDate(date);
                                setStartdate(date);
                                setLabel(convertToDateString(date, "picker"));
                            }
                            if(response.data.dueDate == null) {
                                setLabel('Select Date');
                                setDate(null);
                                setStartdate(null);
                            }

                            // Resend Date
                            if(response.data.resendDate != null) {
                                const date = new Date(response.data.resendDate);
                                setResend((prev) => ({ date: date, startDate: date, label: convertToDateString(date, "picker") }));
                            } else {
                                setResend((prev) => ({ date: null, startDate: null, label: 'Select Date' }));
                            }

                            if(response.data.entities != null) {
                                // Entity
                                var entityPropertyCodeArray = [];
                                var entityIdArray = [];

                                for(var entity of response.data.entities) {
                                    entityPropertyCodeArray.push(entity.propertyCode);
                                    entityIdArray.push(entity.idEntities);
                                }

                                setEntityLabel(entityPropertyCodeArray.join(", "));
                                setEntityId([response.data.entities[0].idEntities]);
                                setCurrentBrand(response.data.brand.idBrand);
                                setBrandId(response.data.brand.idBrand);
                                setInitialBrandId(response.data.brand.idBrand);
                                getResponseEntity.GetEntityList('/api/entity/dropdown', accesstoken, (data) => {
                                console.log("DATA", data.data.data)
                                    if (data.status == 200) {
                                        
                                    } else if(data.status == 401) {
                                        navigate("/login")
                                    }
                                });
                            } 
                            if(response.data.projectType != null) {
                                setprojectTypeLabel(response.data.projectType.projectTypeName);
                                setProjectTypeId(response.data.projectType.idProjectType);
                                setCurrentProjectType(response.data.projectType.idProjectType)
                            }
                            if(response.data.description != null) {
                                setDescription(response.data.description);
                            }
                            if(response.data.adestraReport != null) {
                                setAdestraReport(response.data.adestraReport)
                            }
                            if (response.data.adestraReportResend != null) {
                                setAdestraReportResend(response.data.adestraReportResend);
                            }
                        }
                        setLoading(false);

                        const breadcrumbsList = [
                            { "name": "Home", "url": "" },
                            { "name": "Projects", "url": "projects/list" },
                            { "name": `${response.data.name}: Edit`, "url": "projects/list/1/edit" }
                        ];
                        dispatch(parseBreadcrumbsList(breadcrumbsList));
                    } else if(response.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }
        
        RefreshToken((accesstoken) => CallAPI(accesstoken));
    }, [complete, deleteform, deletefile, deletetask, uploadstate])

    useEffect(() => {
        if(entityid != null && entityid.length > 0) {
            function CallAPI(accesstoken) {
                if(accesstoken === '') {
                    navigate('/login');
                }
                else {
                    getResponse.GetProjectList(`/api/brand/projecttypes?entityId=${entityid[0]}`, accesstoken, (data) => {
                        if (data.status == 200) {
                            const templateArray = [];
                            data.data.data.map((template) => {
                                const templateObject = {id: 0, name: ''}
                                templateObject.id = template["idProjectType"];
                                templateObject.name = template["projectTypeName"];
                                templateArray.push(templateObject);
                            })
                            setProjectTypeList(templateArray);
    
                            templateArray.length > 0 ? setProjectTypeEnable(true) : resetProjectType();
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    });
                }
            }
    
            RefreshToken((accesstoken) => CallAPI(accesstoken));
        } else {
            resetProjectType();
        }
    }, [entityid])

    const resetProjectType = () => {
        setProjectTypeEnable(false);
        setProjectTypeList([]);
        setprojectTypeLabel('Select Project Type');
        setProjectTypeId(null);
    }
    
    const handleEntityDropdown = (ids) => {
        setEntityId(ids);
        for(var entity of entityList) {
            if(ids.includes(entity.id)) {
                setBrandId(entity.brandId);
                break;
            }
        }
    }


    return (
        <div className='edit-project-container'>
            <Header />
            <div className='row edit-project-section'>
                <Sidebar />
                <div className='col-10 edit-project-right'>
                    <Breadcrumbs />
                    {isLoading ?
                        (<Spinner/>) :
                        (<div className='edit-info-details'>
                            <div className='edit-project-content'>
                                <div className='save' onClick={() => SaveProject()}>Save</div>
                                <div className='row label-input-row'>
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-name'>
                                            <label className='required'>Project Name</label>
                                            <div className='input-box'> 
                                                <input id="projectname" type="text" value={ projectname } onChange={(e) => setProjectname(e.target.value)}
                                                maxLength={200}></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${projectDetails.resendDate != null ? 'col-2' : 'col-4' } label-input-col`}>
                                        <div className='label-input label-input-due'>
                                            <label className='required'>Due Date</label>
                                            {(projectDetails.dueDate || projectDetails.dueDate == null || projectDetails.dueDate == '') &&
                                                <Calender minDate={false} maxDate={false} startdate={startdate} 
                                                HandleDate={(date) => handledate(date)} 
                                                HandleLabel={(date) => setLabel(convertToDateString(date, "picker"))} 
                                                label={label}
                                                disablefromto={false} disableto={false}
                                                />
                                            }
                                        </div>
                                    </div>
                                    {projectDetails.resendDate != null && <div className='col-2 label-input-col'>
                                        <div className='label-input label-input-due'>
                                            <label className='required'>Resend Date</label>
                                            {(projectDetails.resendDate || projectDetails.resendDate == null || projectDetails.resendDate == '') &&
                                                <Calender minDate={false} maxDate={false} startdate={resend.startDate} 
                                                HandleDate={(date) => handleResendDate(date)} 
                                                HandleLabel={(date) => setResend(prev => ({ ...prev, label: convertToDateString(date, "picker") }))} 
                                                label={resend.label}
                                                disablefromto={false} disableto={false}
                                                />
                                            }
                                        </div>
                                    </div>}
                                    <div className='col-4 label-input-col'>
                                        <div className='label-input label-input-entity'>
                                            <label className='required'>Property</label>
                                            {
                                                <MultiSelectionDropdown label={entityLabel} selectedItem={(ids) => handleEntityDropdown(ids)}
                                                    handleLabel={(value) => setEntityLabel(value)} list={entityList} 
                                                    selectedBrand={initialBrandId}/>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='row project-type-row'>
                                    <div className='col-4 label-input-col'>
                                        <div className={projectTypeEnable ? 'label-input label-input-entity pointer-all' : 'label-input label-input-entity pointer-none'}>
                                            <label className={projectTypeEnable ? '' : 'dropdown-grey'}>Project Type</label>
                                            <Dropdown label={projectTypeLabel} selectedItem={(name, id) => setProjectTypeId(id)}
                                                handleLabel={(value) => setprojectTypeLabel(value)} list={projectTypeList} enable={projectTypeEnable}/>
                                        </div>
                                    </div>
                                </div>
                                <div className='row report-input-row'>
                                    <div className={`${projectDetails.resendDate != null ? 'col-6' : 'col-12'} label-input-col report-input`}>
                                        <div className='label-input label-input-name'>
                                            <label>Adestra Report</label>
                                            <div className='input-box'> 
                                                <input type="text" value={adestraReport ? adestraReport : ''} onChange={(e) => setAdestraReport(e.target.value)}
                                                maxLength={200}></input>
                                            </div>
                                        </div>
                                    </div>
                                   {projectDetails.resendDate != null && <div className='col-6 label-input-col report-input'>
                                        <div className='label-input label-input-name'>
                                            <label>Adestra Report (Resend)</label>
                                            <div className='input-box'> 
                                                <input type="text" value={adestraReportResend ? adestraReportResend : ''} onChange={(e) => setAdestraReportResend(e.target.value)}
                                                maxLength={200}></input>
                                            </div>
                                        </div>
                                    </div>}
                                </div>
                                <div className='row description-row'>
                                    <div className='col-12'>
                                        <label>Description</label>
                                        { 
                                            <Descriptor defaultdescription={ projectDetails.description && projectDetails.description } setDescription={ setDescription } />
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                projectDetails && projectDetails.tasksClxes &&
                                <ProjectInfo fivetasks={ projectDetails.tasksClxes } fivefiles={ projectDetails.filesClxes} fiveforms={ projectDetails.formSubmissions} setComplete={setComplete} complete={complete}
                                    setDeleteForm={ setDeleteForm } deleteform={ deleteform } setDeleteFile={ setDeleteFile } deletefile={ deletefile }
                                    setDeleteTask={ setDeleteTask } deletetask={ deletetask } setUpload={ setUpload } uploadstate={ uploadstate }
                                    completecount = { projectDetails.completedTasks } showTask={showTask} showTasks={false}
                                />
                            }
                        </div>)}
                </div>
            </div>
            <EditProjectConfirm showeditconfirm={showeditconfirm} handleConfirmHide={handleConfirmHide}  DifferentEntity={DifferentEntity} 
            SameEntity={SameEntity} projectname={projectname} enable={confirmButtonEnable}/>
            <Snackbars error={editerror} open={open} setOpen={setOpen}/>
            <Footer />
        </div>
    );
}

export default EditProject;